module.exports = __webpack_public_path__ + "img/bms.c00a606e.png";